<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col></b-col>
            <b-col class="text-center title">點數兌換券上架 / 商品券上架</b-col>
            <b-col>
                <div class="text-right">
                    <b-btn class="btn btn-ptc1" v-b-toggle.collapse1 >查詢</b-btn>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <b-card class='bg-warning-card'>
                <div class='row'>
                    <b-modal ref='TopModal' hide-footer title='更新置頂'>
                        <b-container fluid>
                            <div class='row mt-3' style='text-align:center;'>
                                <label class='control-label'>確認儲存置頂設定?</label>
                            </div>
                            <div class='float-right'>
                                <b-btn variant='primary' @click='TopModalSave'>確認</b-btn>
                                <b-btn variant='secondary' @click='TopCancel'>取消</b-btn>
                            </div>
                        </b-container>
                    </b-modal>
                    <b-modal size='lg' ref='editTicket' hide-footer :title='this.modelTitle'>
                        <b-container fluid>
                            <form>
                                <div class='float-right'>
                                    <input disabled type='file' class='upload_input' id='editPic' @change='edithandleFileChange' ref='editinputer'>
                                    <label class='upload_block' for='editPic'>
                                        <span class='upload_icon'>➕</span>
                                        <img class='upload_img' :src='editdataUrl' />
                                    </label>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>券別ID：</label>
                                    <div class='col-md-7'>
                                        <input disabled type='text' class='form-control' v-model='editId' placeholder='ID'>
                                    </div>
                                </div>
                                <div class='row mb-3' >
                                  <label class='control-label col-md-3'>是否為贈卷用：</label>
                                  <div class='col-md-7'>
                                    {{(editAppSwap === true) ? '否' : '是'}}
                                  </div>
                                </div>
                                <div class='row mb-3'>
                                  <label class='control-label col-md-3'>是否允許會員互相轉贈：</label>
                                  <div class='col-md-9'>
                                    {{ editAllowTransfer ? '是' : '否' }}
                                  </div>
                                </div>
                                <div class='row mb-3' v-show="editAppSwap==true">
                                    <label class='control-label col-md-3'>APP分類：</label>
                                    <div class='col-md-7'>
                                        <select disabled id='editAppType' name='editAppType' class='form-control' v-model='editAppType'>
                                            <option disabled value=''>請選擇</option>
                                            <option v-for='x in selectListAppType' v-bind:value='x.id' :key="x.id">{{x.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label :class="editAppSwap == false ? 'control-label col-md-3':'control-label col-md-2'">票券名稱：</label>
                                    <div class='col-md-7'>
                                        <input disabled type='text' class='form-control' v-model='editTicketName' placeholder='請輸入票券名稱'>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>票券類別：</label>
                                    <div class='col-md-5'>
                                        <select disabled id='editTicketType' name='editTicketType' class='form-control' v-model='editTicketType'>
                                            <option disabled value=''>請選擇</option>
                                            <option v-for='x in selectListTicketType' v-bind:value='x.code+x.id' :key="x.code+x.id">{{x.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>發行型態：</label>
                                    <div class='col-md-8'>
                                        <table>
                                            <tr>
                                                <td>
                                                    <input disabled type='radio' id='editTicketSpecies1' value=1 v-model='editTicketSpecies'>
                                                    <label for='editTicketSpecies1'>常態</label>
                                                </td>
                                                <td><input disabled type='number' class='form-control' placeholder='請輸入兌換後可使用天數' v-model='editTicketSpeciesDay'></td>
                                                <td><label class='control-label'>天</label></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input disabled type='radio' id='editTicketSpecies2' value=2 v-model='editTicketSpecies'>
                                                    <label for='editTicketSpecies2'>限量</label>
                                                </td>
                                                <td><input disabled type='number' class='form-control' placeholder='請輸入限量張數' v-model='editTicketSpeciesQty'></td>
                                                <td><label class='control-label' style="padding-right:20px">張</label></td>
                                                <td >
                                                    <label class='control-label'>免費</label>
                                                    <toggle-button disabled v-model="editFree" :sync="true" :height=30 :width=60 style="font-size: 14px;" :labels="{checked: '是', unchecked: '否'}" :color="{checked: '#09BD8F', unchecked: '#dc6460'}" />
                                                </td>
                                            </tr>
                                            <tr v-if="editTicketSpecies == 2">
                                                <td>
                                                </td>
                                                <td colspan='3'>
                                                  <table>
                                                    <tr>
                                                      <td colspan='3'>
                                                        <input type='radio' name='rdoLimitBuy' value=1 disabled v-model='editTicketBuy'>
                                                        <label>會員限兌換一次一張</label>
                                                      </td>
                                                    </tr>
                                                    <tr>
                                                      <td>
                                                        <input type='radio' name='rdoLimitBuy' value=2 disabled v-model='editTicketBuy'>
                                                        <label>會員每日限購</label>
                                                      </td>
                                                      <td>
                                                          <input disabled type='number' class='form-control' placeholder='請輸入限購張數' v-model='editTicketBuyQty'>
                                                      </td>
                                                      <td>
                                                          <label class='control-label' style="padding-right:20px">張</label>
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>上架時間：</label>
                                    <div class='col-md-4'>
                                        <input disabled type='date' class='form-control' v-model='editSaleDay_S'>
                                    </div>
                                    <label class='control-label'></label>
                                    <div class='col-md-4'>
                                        <input disabled type='text' class='form-control' v-model='editSaleDay_STime'>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>下架時間：</label>
                                    <div class='col-md-4'>
                                        <input disabled type='date' class='form-control' v-model='editSaleDay_E'>
                                    </div>
                                    <label class='control-label'></label>
                                    <div class='col-md-4'>
                                        <input disabled type='text' class='form-control' v-model='editSaleDay_ETime'>
                                    </div>
                                </div>
                                <div class='row mb-3' v-show="editAppSwap==true">
                                    <label class='control-label col-md-2'>上架週期：</label>
                                    <div class='col-md-7'>
                                        <b-form-group>
                                            <b-form-checkbox-group v-model="editWeek" :options="optionsWeek" ></b-form-checkbox-group>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class='row mb-3' v-if='editTicketSpecies == 2 && editAppSwap==true'>
                                    <label class='control-label col-md-2'>兌換期間：</label>
                                    <div class='col-md-4'>
                                        <input disabled type='date' class='form-control' v-model='editUseDay_S'>
                                    </div>
                                    <label class='control-label'>至</label>
                                    <div class='col-md-4'>
                                        <input disabled type='date' class='form-control' v-model='editUseDay_E'>
                                    </div>
                                </div>
                                <hr>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>兌換規則：</label>
                                    <div class='col-md-10'>
                                        <table>
                                            <tr>
                                                <td>
                                                    <label class='control-label'>兌換點數</label>
                                                </td>
                                                <td>
                                                    <input disabled type='number' class='form-control' v-model='editPoint'>
                                                </td>
                                                <td>
                                                    <label v-if='editTicketType.substr(0,3) == "A01"' class='control-label'>折抵</label>
                                                    <label v-if='editTicketType.substr(0,3) == "C01"' class='control-label'>折扣</label>
                                                </td>
                                                <td>
                                                    <input v-if='editTicketType.substr(0,3) != "G01"' disabled type='number' class='form-control' v-model='editMoney'>
                                                    <input v-if='editTicketType.substr(0,3) == "G01"' disabled type='text' class='form-control' v-model='editText' placeholder='請輸入兌換活動'>
                                                </td>
                                                <td>
                                                    <label v-if="editTicketType.substr(0,3) == 'A01'" class='control-label'>元</label>
                                                    <label v-if="editTicketType.substr(0,3) == 'C01'" class='control-label'>折</label>
                                                    <label v-if="editTicketType.substr(0,3) == 'C01'" class='control-label'>EX:9折=0.9</label>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>使用管道：</label>
                                    <div class='col-md-10'>
                                        <input type='radio' name='rdoUseType' value=1 disabled v-model='editUseType'>
                                        <label>全部</label>
                                        <input type='radio' name='rdoUseType' value=2 disabled v-model='editUseType'>
                                        <label>POS</label>
                                        <input type='radio' name='rdoUseType' value=3 disabled v-model='editUseType'>
                                        <label>APP</label>
                                    </div>
                                </div>
                                <div class='row mb-3' v-if="editUseType!=2">
                                    <label class='control-label col-md-2'>線上訂餐規則：</label>
                                    <div class='col-md-10'>
                                        <table>
                                            <tr v-if="editTicketType.substr(0,3)=='G01'">
                                                <td>
                                                    <label class='control-label'>優惠規則</label>
                                                </td>
                                                <td>
                                                    <select id='Input_TicketRule' name='Input_TicketRule' class='form-control' disabled v-model='editTicketRule'>
                                                        <option disabled value=''>請選擇</option>
                                                        <option value='1'>買A送B</option>
                                                        <option value='2'>商品折價</option>
                                                        <option value='3'>商品特價</option>
                                                        <option value='4'>商品第二件N折</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr v-if="editTicketType.substr(0,3)=='G01' && editTicketRule!=''">
                                                <td>
                                                    <label class='control-label'>買</label>
                                                </td>
                                                <td><input disabled type='text' class='form-control' v-model='editProduct_A'>
                                                </td>
                                            </tr>
                                            <tr v-if="editTicketType.substr(0,3)=='G01' && editTicketRule=='1'">
                                                <td>
                                                    <label class='control-label'>送</label>
                                                </td>
                                                <td><input disabled type='text' class='form-control' v-model='editProduct_B'>
                                                </td>
                                            </tr>
                                            <tr v-if="editTicketType.substr(0,3)=='G01' && !(editTicketRule=='' || editTicketRule=='1')">
                                                <td>
                                                    <label class='control-label' v-show="editTicketRule=='2'">折價</label>
                                                    <label class='control-label' v-show="editTicketRule=='3'">特價</label>
                                                    <label class='control-label' v-show="editTicketRule=='4'">折扣</label>
                                                </td>
                                                <td>
                                                    <input type='number' class='form-control' name="InputSaleDiscount" placeholder='請輸入數值' disabled v-model='editSaleDiscount'>
                                                </td>
                                                <td>
                                                    <label class='control-label' v-show="editTicketRule!='2'">元</label>
                                                    <label class='control-label' v-show="editTicketRule=='4'">折 EX:9折=0.9</label>
                                                </td>
                                            </tr>
                                            <tr v-if="editTicketType.substr(0,3)!='G01'">
                                                <td>
                                                    <label class='control-label'>滿</label>
                                                </td>
                                                <td>
                                                    <input type='number' class='form-control' name="InputSaleDiscount" placeholder='請輸入數值' disabled v-model='editUseAmount'>
                                                </td>
                                                <td>
                                                    <label class='control-label'>元使用</label>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>票券使用品牌：</label>
                                    <div class='col-md-9'>
                                        <b-form-checkbox-group v-model="selectBrands" style="overflow: auto" stacked>
                                          <b-form-checkbox v-for="x in selectListBrands" :value="x.Code" :key="x.Code" disabled>{{x.Text}}</b-form-checkbox>
                                        </b-form-checkbox-group>
                                        <div class="text-danger" style="padding: 0.3rem" v-if="v_BrandMsg != ''">{{v_BrandMsg}}</div>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                <label class='control-label col-md-3'>票券使用模式：</label>
                                <div class='col-md-9'>
                                    <input type='radio' name='rdoStoreMode' value=0 v-model='storeMode' disabled>
                                    <label>指定品牌</label>
                                    <input type='radio' name='rdoStoreMode' value=1 v-model='storeMode' disabled>
                                    <label>指定門市</label>
                                    <input type='radio' name='rdoStoreMode' value=2 v-model='storeMode' disabled>
                                    <label>全品牌</label>
                                    <div class='col-md-5'>
                                        <p class="text-primary cursor_add_store" @click="addStoreShow()">{{showStoreWord}}</p>
                                    </div>
                                </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>票券使用時段：</label>
                                    <div class='col-md-2'>
                                        <div>
                                        <input type='number' name='Input_UseStartAt' class='form-control' v-model='useStartAt' disabled>
                                        </div>
                                    </div>
                                    <label class='control-label'>至</label>
                                    <div class='col-md-2'>
                                        <div>
                                        <input type='number' name='Input_UseEndAt' class='form-control' v-model='useEndAt' disabled>
                                        </div>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-3'>票券平假日使用設定：</label>
                                    <div class='col-md-9'>
                                    <input type='radio' name='rdoDayMode' value=0 v-model='dayMode' disabled>
                                    <label>不分平假日</label>
                                    <input type='radio' name='rdoDayMode' value=1 v-model='dayMode' disabled>
                                    <label>平日</label>
                                    <input type='radio' name='rdoDayMode' value=2 v-model='dayMode' disabled>
                                    <label>假日</label>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <label class='control-label col-md-3' for="memo">票券提示文字：</label>
                                    <div>
                                        <input v-model="memo" id="memo" name="Input_Memo" type="text" autofocus disabled  class="form-control"/>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <label class='control-label col-md-3'>票券補貼點數：</label>
                                    <div>
                                        <input v-model="pointSubsidy" type="text" autofocus disabled class="form-control"/>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>備註條款：</label>
                                    <div class='col-md-10'>
                                        <div disabled style="border-style:solid;border-color:#CED4DA;background-color:#E9ECEF;padding:5px;border-width:1px" v-html="content"></div>
                                    </div>
                                </div>
                                <div class='row mb-3'>
                                    <label class='control-label col-md-2'>異動人員：</label>
                                    <div class='col-md-3'>
                                        <input disabled type='text' class='form-control' v-model='editUpdId'>
                                    </div>
                                    <label class='control-label'>異動時間：</label>
                                    <div class='col-md-4'>
                                        <input disabled type='text' class='form-control' v-model='editUpdTime'>
                                    </div>
                                </div>
                                <div class='row mb-3' v-if='this.modelType!=2 && this.modelType!=4 && editAppSwap==true'>
                                    <label class='control-label col-md-2'>發佈人員：</label>
                                    <div class='col-md-3'>
                                        <input disabled type='text' class='form-control' v-model='editCheckUpdId'>
                                    </div>
                                    <label class='control-label'>發佈時間：</label>
                                    <div class='col-md-4'>
                                        <input disabled type='text' class='form-control' v-model='editCheckUpdTime'>
                                    </div>
                                </div>
                                <div class='float-right'>
                                    <b-btn variant='primary' @click='editCancel'>關閉</b-btn>
                                </div>
                            </form>
                        </b-container>
                    </b-modal>
                    <b-modal ref='previewTicket' hide-footer title='電子票券'>
                        <b-container fluid>
                            <form>
                                <div>
                                    <div class='float-left col-md-5'>
                                        <img style='width:100%' :src='previewSrc' alt=''>
                                    </div>
                                    <div class='col-md-7' style='float:right;'>
                                        <div class='row' style='font-size:large;'>{{previewName}}</div>
                                        <div v-if='previewPublished === 2' class='row' style='font-size:large;'>兌換期限：{{previewSaleDateE}}</div>
                                        <div class='row' style='font-size:large; font-weight:bolder; color: #FF5511'>{{previewPoint}}點 {{previewDiscount}}</div>
                                    </div>
                                </div>
                            </form>
                        </b-container>
                    </b-modal>
                </div>
                <div class="row">
                    <div class='col-lg-12'>
                        <b-tabs card class="tab_color">
                            <b-tab title='已上架票券' @click="changeTab(1)" :active='this.modelTab == 1'>
                                <div class='row mt-3'></div>
                                <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                                    <b-card class='bg-default-card'>
                                        <div class='row'>
                                            <div class='col-lg-12'>
                                                <div class='p-4 box-shadow' header='Form Elements'>
                                                    <div class='row'>
                                                        <label class='control-label col-md-2'>APP分類：</label>
                                                        <div class='col-md-4'>
                                                            <select id='queryAppType1' name='queryAppType1' class='form-control' v-model='queryTab1.queryAppType1'>
                                                                <option value=0>全部</option>
                                                                <option v-for='x in selectListAppType' v-bind:value='x.id' :key="x.id">{{x.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-2'>票券類別：</label>
                                                        <div class='col-md-4'>
                                                            <select id='queryTciketType1' name='queryTciketType1' class='form-control' v-model='queryTab1.queryTciketType1'>
                                                                <option value=''>全部</option>
                                                                <option v-for='x in selectListTicketType' v-bind:value='x.code+x.id' :key="x.code+x.id">{{x.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-2'>票券名稱：</label>
                                                        <div class='col-md-4'>
                                                            <input type='text' class='form-control' placeholder='請輸入票券名稱 (模糊查詢)' v-model='queryTab1.queryTciketName1'>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-2'>發行型態：</label>
                                                        <div class='col-md-4'>
                                                            <select id='queryTciketPublished1' name='queryTciketPublished1' class='form-control' v-model='queryTab1.queryTciketPublished1'>
                                                                <option value='0'>全部</option>
                                                                <option v-for='x in selectListPublished' v-bind:value='x.t_Sid' :key="x.t_Sid">{{x.t_SName}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <div class='text-red' style='color:#FF0000;text-align:center;'>*</div><label class='control-label col-md-2'>上架狀態：</label>
                                                        <div class='col-md-6'>
                                                            <b-form-checkbox id='querySaleNow' class='warningcheck' v-model="querySaleNow" value="yes" unchecked-value="no" :checked='true'>上架中</b-form-checkbox>
                                                            <b-form-checkbox id='querySaleSchedule' class='warningcheck' v-model="querySaleSchedule" value="yes" unchecked-value="no">已排程</b-form-checkbox>
                                                        </div>
                                                        <div class='col-md-3'>
                                                            <button type='button' class='btn btn-warning text-white ' @click="search(1)">查詢</button>
                                                            <button type='reset' class='btn btn-warning text-white' @click.prevent="resetForm1">重設</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                                <div>
                                    <div class='row'>
                                        <div class='col-lg-12 mb-3'>
                                            <div class='table-responsive'>
                                                <div class="text-right">
                                                    <router-link v-show='btn_top && FunctionPermission > 1' :to="{ name: 'coupon_exchange_add', params: { queryTab0: queryTab0, querySaleNow: querySaleNow, querySaleSchedule: querySaleSchedule, queryTab1: queryTab1, queryTab2: queryTab2, modelTab: tab, collapse: collapse}  }" class='btn btn-outline-light'>新增票券</router-link>
                                                    <button type='button' class='btn btn-warning text-white' v-show='btn_top && FunctionPermission > 1' @click='btnTop'>置頂</button>
                                                    <button type='button' class='btn btn-warning text-white' v-show='!btn_top && FunctionPermission > 1' @click='TopModalSave'>儲存</button>
                                                    <button type='button' class='btn btn-secondary' v-show='!btn_top && FunctionPermission > 1' @click='btnTop'>取消</button>
                                                </div>
                                                <table id='mytable' class='table table-bordred table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th>項次</th>
                                                            <th>券別ID</th>
                                                            <th>APP分類</th>
                                                            <th>票券別</th>
                                                            <th>圖片</th>
                                                            <th>票券名稱</th>
                                                            <th>上架/下架期間</th>
                                                            <th>狀態</th>
                                                            <th>異動人</th>
                                                            <th>異動時間</th>
                                                            <th>置頂</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for='(x, index) in listTicket1' :key="x.id">
                                                            <td>{{((queryTab1.currentPage-1)*pageRows+index+1)}}</td>
                                                            <td>{{x.code}}</td>
                                                            <td>{{x.appCategoryName}}</td>
                                                            <td>{{x.posCategoryName}}</td>
                                                            <td>
                                                                <b-btn style='background-color: transparent;border:0' @click='previewTicket(x)' class='mb-3 small_img'>
                                                                    <img :src='x.imageURL' class='img-fluid' width='100' alt='phone image'>
                                                                </b-btn>
                                                            </td>
                                                            <td>{{x.name}}</td>
                                                            <td>{{x.enabledAt}}&nbsp;{{x.enabledAtTime}}<br>{{x.disabledAt}}&nbsp;{{x.disabledAtTime}}</td>
                                                            <td v-if='x.statusDesc=="上架中"'>
                                                                <font color="red">{{x.statusDesc}}</font>
                                                            </td>
                                                            <td v-if='x.statusDesc!="上架中"'>{{x.statusDesc}}</td>
                                                            <td>{{x.updatedName}}</td>
                                                            <td>{{x.updatedAt}}</td>
                                                            <td>
                                                                <b-form-checkbox :disabled='btn_top' :checked='!btn_top? Top.map(item => Object.values(item)[0]).indexOf(x.id) >= 0? true: false: x.top' @change='topChange($event,x)'></b-form-checkbox>
                                                            </td>
                                                            <td>
                                                                <router-link :disabled='!btn_top' :to="{ name: 'coupon_exchange_edit', params: { item: x, queryTab0: queryTab0, querySaleNow: querySaleNow, querySaleSchedule: querySaleSchedule, queryTab1: queryTab1, queryTab2: queryTab2, modelTab: tab, collapse: collapse } }" class="btn-circle btn-circle-ptc1" v-show='FunctionPermission > 1' tag="button"><i class="fas fa-pencil-alt" title="編輯"></i></router-link> <!-- 分頁處理 -->
                                                                <button class='btn-circle btn-circle-ptc1' @click='showTicketDetail(x, 1)'><span class='fa fa-search-plus'></span></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="row" style="padding: 0 1rem">
                                                <b-pagination size="md" :total-rows="queryTab1.totalRows" v-model="queryTab1.currentPage" :per-page="pageRows" @change="search"></b-pagination>
                                                <label style="margin:8px">{{queryTab1.startRowNum}}到{{queryTab1.endRowNum}}，總共 {{queryTab1.totalRows}}筆</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title='待審核票券' @click="changeTab(0)" :active='this.modelTab == 0'>
                                <div class='row mt-3'></div>
                                <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                                    <b-card class='bg-default-card'>
                                        <div class='row'>
                                            <div class='col-lg-12'>
                                                <div class='p-4 box-shadow' header='Form Elements'>
                                                    <div class='row'>
                                                        <label class='control-label col-md-2'>APP分類：</label>
                                                        <div class='col-md-4'>
                                                            <select id='queryAppType0' name='queryAppType0' class='form-control' v-model='queryTab0.queryAppType0'>
                                                                <option value='0'>全部</option>
                                                                <option v-for='x in selectListAppType' v-bind:value='x.id' :key="x.id">{{x.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-2'>票券類別：</label>
                                                        <div class='col-md-4'>
                                                            <select id='queryTciketType0' name='queryTciketType0' class='form-control' v-model='queryTab0.queryTciketType0'>
                                                                <option value=''>全部</option>
                                                                <option v-for='x in selectListTicketType' v-bind:value='x.code+x.id' :key="x.code+x.id">{{x.name}}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-2'>票券名稱：</label>
                                                        <div class='col-md-4'>
                                                            <input type='text' class='form-control' placeholder='請輸入票券名稱 (模糊查詢)' v-model='queryTab0.queryTciketName0'>
                                                        </div>
                                                    </div>
                                                    <div class='row mt-3'>
                                                        <label class='control-label col-md-2'>發行型態：</label>
                                                        <div class='col-md-4'>
                                                            <select id='queryTciketPublished0' name='queryTciketPublished0' class='form-control' v-model='queryTab0.queryTciketPublished0'>
                                                                <option value='0'>全部</option>
                                                                <option v-for='x in selectListPublished' v-bind:value='x.t_Sid' :key="x.t_Sid">{{x.t_SName}}</option>
                                                            </select>
                                                        </div>
                                                        <div class='col-md-3'>
                                                            <button type='button' class='btn btn-warning text-white ' @click="search(1)">查詢</button>
                                                            <button type='reset' class='btn btn-warning text-white' @click.prevent="resetForm0">重設</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-card>
                                </b-collapse>
                                <div>
                                    <div class='row'>
                                        <div class='col-lg-12 mb-3'>
                                            <div class='table-responsive'>
                                                <div class="text-right">
                                                    <router-link :to="{ name: 'coupon_exchange_add', params: { queryTab0: queryTab0, querySaleNow: querySaleNow, querySaleSchedule: querySaleSchedule, queryTab1: queryTab1, queryTab2: queryTab2, modelTab: tab, collapse: collapse } }" v-show='FunctionPermission > 1' class='btn btn-outline-light'>新增票券</router-link>
                                                </div>
                                                <table id='checkTable' class='table table-bordred table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th>項次</th>
                                                            <th>券別ID</th>
                                                            <th>APP分類</th>
                                                            <th>票券別</th>
                                                            <th>圖片</th>
                                                            <th>票券名稱</th>
                                                            <th>上架/下架期間</th>
                                                            <th>異動人員</th>
                                                            <th>異動時間</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for='(x, index) in listTicket0' :key="x.id">
                                                            <td>{{((queryTab0.currentPage-1)*pageRows+index+1)}}</td>
                                                            <td>{{x.code}}</td>
                                                            <td>{{x.appCategoryName}}</td>
                                                            <td>{{x.posCategoryName}}</td>
                                                            <td>
                                                                <b-btn style='background-color: transparent;border:0' @click='previewTicket(x)' class='mb-3 small_img'>
                                                                    <img :src='x.imageURL' class='img-fluid' width='100' alt='phone image'>
                                                                </b-btn>
                                                            </td>
                                                            <td>{{x.name}}</td>
                                                            <td>{{x.enabledAt}}&nbsp;{{x.enabledAtTime}}<br>{{x.disabledAt}}&nbsp;{{x.disabledAtTime}}</td>
                                                            <td>{{x.updatedName}}</td>
                                                            <td>{{x.updatedAt}}</td>
                                                            <td>
                                                                <router-link :to="{ name: 'coupon_exchange_edit', params: { item: x, queryTab0: queryTab0, querySaleNow: querySaleNow, querySaleSchedule: querySaleSchedule, queryTab1: queryTab1, queryTab2: queryTab2, modelTab: tab, collapse: collapse } }" class="btn-circle btn-circle-ptc1" tag="button" v-show='FunctionPermission > 1'><i class="fas fa-pencil-alt" title="編輯"></i></router-link> <!-- 分頁處理 -->
                                                                <button class='btn-circle btn-circle-ptc1' @click='showTicketDetail(x, 0)'><span class='fa fa-search-plus'></span></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="row" style="padding: 0 1rem">
                                                <b-pagination size="md" :total-rows="queryTab0.totalRows" v-model="queryTab0.currentPage" :per-page="pageRows" @change="search"></b-pagination>
                                                <label style="margin:8px">{{queryTab0.startRowNum}}到{{queryTab0.endRowNum}}，總共 {{queryTab0.totalRows}}筆</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title='已下架票券' @click="changeTab(2)" :active='this.modelTab == 2'>
                                <div class='row mt-3'></div>
                                <b-collapse id="collapse1" class="mt-2" style="margin-bottom: 10px;">
                                            <b-card class='bg-default-card'>
                                                <div class='row'>
                                                    <div class='col-lg-12'>
                                                        <div class='p-4 box-shadow' header='Form Elements'>
                                                            <div class='row'>
                                                                <label class='control-label col-md-2'>APP分類：</label>
                                                                <div class='col-md-4'>
                                                                    <select id='queryAppType2' name='queryAppType2' class='form-control' v-model='queryTab2.queryAppType2'>
                                                                        <option value='0'>全部</option>
                                                                        <option v-for='x in selectListAppType' v-bind:value='x.id' :key="x.id">{{x.name}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class='row mt-3'>
                                                                <label class='control-label col-md-2'>票券類別：</label>
                                                                <div class='col-md-4'>
                                                                    <select id='queryTciketType2' name='queryTciketType2' class='form-control' v-model='queryTab2.queryTciketType2'>
                                                                        <option value=''>全部</option>
                                                                        <option v-for='x in selectListTicketType' v-bind:value='x.code+x.id' :key="x.code+x.id">{{x.name}}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div class='row mt-3'>
                                                                <label class='control-label col-md-2'>票券名稱：</label>
                                                                <div class='col-md-4'>
                                                                    <input type='text' class='form-control' placeholder='請輸入票券名稱 (模糊查詢)' v-model='queryTab2.queryTciketName2'>
                                                                </div>
                                                            </div>
                                                            <div class='row mt-3'>
                                                                <label class='control-label col-md-2'>發行型態：</label>
                                                                <div class='col-md-4'>
                                                                    <select id='queryTciketPublished2' name='queryTciketPublished2' class='form-control' v-model='queryTab2.queryTciketPublished2'>
                                                                        <option value='0'>全部</option>
                                                                        <option v-for='x in selectListPublished' v-bind:value='x.t_Sid' :key="x.t_Sid">{{x.t_SName}}</option>
                                                                    </select>
                                                                </div>
                                                                <div class='col-md-3'>
                                                                    <button type='button' class='btn btn-warning text-white ' @click="search(1)">查詢</button>
                                                                    <button type='reset' class='btn btn-warning text-white' @click.prevent="resetForm2">重設</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </b-card>
                                </b-collapse>
                                <div>
                                    <div class='row'>
                                        <div class='col-lg-12 mb-3'>
                                            <div class='table-responsive'>
                                                <table id='mytable' class='table table-bordred table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th>項次</th>
                                                            <th>券別ID</th>
                                                            <th>APP分類</th>
                                                            <th>票券別</th>
                                                            <th>圖片</th>
                                                            <th>票券名稱</th>
                                                            <th>上架/下架期間</th>
                                                            <th>異動人</th>
                                                            <th>異動時間</th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for='(x, index) in listTicket2' :key="x.id">
                                                            <td>{{((queryTab2.currentPage-1)*pageRows+index+1)}}</td>
                                                            <td>{{x.code}}</td>
                                                            <td>{{x.appCategoryName}}</td>
                                                            <td>{{x.posCategoryName}}</td>
                                                            <td>
                                                                <b-btn style='background-color: transparent;border:0' @click='previewTicket(x)' class='mb-3 small_img'>
                                                                    <img :src='x.imageURL' class='img-fluid' width='100' alt='phone image'>
                                                                </b-btn>
                                                            </td>
                                                            <td>{{x.name}}</td>
                                                            <td>{{x.enabledAt}}&nbsp;{{x.enabledAtTime}}<br>{{x.disabledAt}}&nbsp;{{x.disabledAtTime}}</td>
                                                            <td>{{x.updatedName}}</td>
                                                            <td>{{x.updatedAt}}</td>
                                                            <td>
                                                                <button class='btn-circle btn-circle-ptc1' @click='showTicketDetail(x, 2)'><span class='fa fa-search-plus'></span></button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="row" style="padding: 0 1rem">
                                                <b-pagination size="md" :total-rows="queryTab2.totalRows" v-model="queryTab2.currentPage" :per-page="pageRows" @change="search"></b-pagination>
                                                <label style="margin:8px">{{queryTab2.startRowNum}}到{{queryTab2.endRowNum}}，總共 {{queryTab2.totalRows}}筆</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title='APP分類設定' @click="changeTab(3)">
                                <div class='row'>
                                    <div class='col-lg-12'>
                                        <div class='table-responsive'>
                                            <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit_APP">
                                                <div class='float-right'>
                                                    <div class='float-right'>
                                                        <table>
                                                            <tr>
                                                                <td v-if='!btn_add' colspan="3">
                                                                    <label>{{editOldAppTypeName}}</label>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td v-if='!btn_add'>
                                                                    <label>{{iAppTypeStatusDesc}}APP分類名稱：</label>
                                                                </td>
                                                                <td v-if='!btn_add'>
                                                                    <validate tag="div">
                                                                        <input type='text' name='InputName' class='form-control' v-model.trim='editAppTypeName' ref="rAppTypeName" maxlength="6" required>
                                                                        <field-messages name="InputName" show="$invalid && $submitted" class="text-danger">
                                                                            <div slot="required">請輸入APP分類名稱</div>
                                                                        </field-messages>
                                                                    </validate>
                                                                </td>
                                                                <td>
                                                                    <button type='button' class='btn btn-outline-light' v-show='btn_order && btn_add && FunctionPermission > 1' @click='addAppTypeBy'>新增APP分類</button>
                                                                    <button type='button' class='btn btn-warning text-white' v-show='btn_order && btn_add && FunctionPermission > 1' @click='editOrderBy'>重新排序</button>

                                                                    <button type='submit' class='btn btn-save' v-show='!btn_add && FunctionPermission > 1'>儲存</button>
                                                                    <button type='reset' class='btn btn-clear' v-show='!btn_add && FunctionPermission > 1' @click='editAppTypeCancel'>取消</button>
                                                                    <!-- 排序用按鈕 -->
                                                                    <button type='button' class='btn btn-save' v-show='!btn_order && FunctionPermission > 1' @click='orderAppType'>儲存</button>
                                                                    <button type='button' class='btn btn-clear' v-show='!btn_order && FunctionPermission > 1' @click='orderAppTypeCancel'>取消</button>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </vue-form>
                                            <table id='AppTypeTable' class='table table-bordred table-striped'>
                                                <thead>
                                                    <tr>
                                                        <th>APP分類</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <draggable v-model='listAppType' element='tbody' :options="dragOptions">
                                                    <tr v-for='(x, index) in listAppType' :key='x.id'>
                                                        <td>{{x.name}}</td>
                                                        <td>
                                                            <button class='btn-circle btn-circle-ptc1 ' :disabled='!btn_order' @click='editAppTypeBy(index)' v-show='FunctionPermission > 1'><span class='fas fa-pencil-alt' title="編輯"></span></button>
                                                            <button v-if='!x.hasdetail' class='btn-circle btn-circle-ptc1' :disabled='!btn_order' v-show='FunctionPermission > 1' @click='delAppTypeByOpen(index)'><span class='fas fa-trash-alt' title="刪除"></span></button>
                                                        </td>
                                                    </tr>
                                                </draggable>
                                            </table>
                                            <div>
                                                <label style="margin:8px">{{appTypeStartRowNum}}到{{appTypeEndRowNum}}，總共 {{appTypeEndRowNum}}筆</label>
                                            </div>
                                        </div>
                                        <b-modal ref='editAppTypeModal' hide-footer :title='modalTitleForAPPType'>
                                            <b-container fluid>
                                                <div class='row mt-3' style='text-align:center;'>
                                                    <label class='control-label'>確認{{this.iAppTypeStatusDesc}}「{{editAppTypeName}}」?</label>
                                                </div>
                                                <div class='float-right'>
                                                    <b-btn variant='primary' @click='editAppTypeModalSave'>確認</b-btn>
                                                    <b-btn variant='secondary' @click='editAppTypeModalCancel'>取消</b-btn>
                                                </div>
                                            </b-container>
                                        </b-modal>
                                        <b-modal size='lg' ref="addStore" hide-footer title="已新增門市">
                                            <div class="row">
                                                <label class="control-label col-md-2 mt-2 text-right">地區：</label>
                                                <div class="col-md-3">
                                                    <multiselect
                                                        id="city"
                                                        v-model="city"
                                                        :options="Array.from(citylist.keys())"
                                                        @input="cityChange"
                                                        :show-labels="false"
                                                        :multiple="false"
                                                        placeholder="請選擇"
                                                    >
                                                        <template slot="option" slot-scope="{ option }">
                                                            <span>
                                                            {{ option }}
                                                            <i class="fa fa-check" v-if="selectedCity.includes(option)" style="margin-left: 5px;"></i>
                                                            </span>
                                                        </template>
                                                        <span slot="noResult">查無資料</span>
                                                    </multiselect>
                                                </div>
                                                <label class="control-label col-md-2 mt-2 text-right">門市：</label>
                                                <div class="col-md-4">
                                                    <multiselect v-model="store" :options="storelist" :multiple="false" :custom-label="nameWithLang" :placeholder="placeholderText" label="Name" track-by="Name" :show-labels="false" :disabled="isDisable">
                                                        <span slot="noResult">查無資料</span>
                                                    </multiselect>
                                                </div>
                                                <div>
                                                    <button type="button" class="btn btn-warning text-white" @click="handleSearch()">查詢</button>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12">
                                                <div class="p-4 box-shadow" header="Form Elements">
                                                    <table id="mytable" class="table table-bordred table-striped mt-3 table-break">
                                                    <thead>
                                                        <tr>
                                                            <th width="10%">項次</th>
                                                            <th width="20%">地區</th>
                                                            <th width="33%">門市名稱</th>
                                                            <th width="33%">門市代碼</th>
                                                        </tr>
                                                        <tr v-for="v in showStoreList" :key="v.ID">
                                                            <td>{{v.Seq}}</td>
                                                            <td>{{v.City}}</td>
                                                            <td>{{v.Name}}</td>
                                                            <td>{{v.Code}}</td>
                                                        </tr>
                                                    </thead>
                                                    </table>
                                                    <div>
                                                        <div class="row" style="padding: 0 1rem">
                                                            <b-pagination size="md" :total-rows="model1.totalrows" v-model="model1.currentPage" :per-page="model1.rows" @change="getSearchStoreList"></b-pagination>
                                                            <label style="margin:8px">{{model1.startRowNum}}到{{model1.endRowNum}}，總共 {{model1.totalrows}}筆</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                        </b-modal>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script src='//cdnjs.cloudflare.com/ajax/libs/vue/2.5.2/vue.min.js'></script>
<script src='//cdn.jsdelivr.net/npm/sortablejs@1.7.0/Sortable.min.js'></script>
<script src='//cdnjs.cloudflare.com/ajax/libs/Vue.Draggable/2.15.0/vuedraggable.min.js'></script>
<script>
import Vue from 'vue'
import draggable from 'vuedraggable'
// 功能權限function
import {getFunctionPermission} from '@/js/LoginUserFunction.js'
import axios from 'axios'
import { API_URL } from '@/store/root.js'
import miniToastr from 'mini-toastr'
import ToggleButton from 'vue-js-toggle-button'
import Multiselect from 'vue-multiselect'
miniToastr.init()
Vue.use(ToggleButton)
Vue.component('multiselect', Multiselect)

export default {
  components: {
        Multiselect
    },
    data () {
        return {
            modelTab: 1,
            collapse: false,
            tab: 1,
            queryTab0: {
                queryAppType0: 0, // 查詢條件:APP分類
                queryTciketType0: '', // 查詢條件:票券類別
                queryTciketName0: '', // 查詢條件:票券名稱
                queryTciketPublished0: 0, // 查詢條件:發行型態
                currentPage: 1, // 目前頁碼
                totalRows: 0, // 總筆數
                startRowNum: 0,
                endRowNum: 0
            },
            queryTab1: {
                queryAppType1: 0, // 查詢條件:APP分類
                queryTciketType1: '', // 查詢條件:票券類別
                queryTciketName1: "", // 查詢條件:票券名稱
                queryTciketPublished1: 0, // 查詢條件:發行型態
                currentPage: 1, // 目前頁碼
                totalRows: 0, // 總筆數
                startRowNum: 0,
                endRowNum: 0
            },
            queryTab2: {
                queryAppType2: 0, // 查詢條件:APP分類
                queryTciketType2: '', // 查詢條件:票券類別
                queryTciketName2: '', // 查詢條件:票券名稱
                queryTciketPublished2: 0, // 查詢條件:發行型態
                currentPage: 1, // 目前頁碼
                totalRows: 0, // 總筆數
                startRowNum: 0,
                endRowNum: 0
            },
            searchAppType1: 0,
            pageRows: 20, // 一頁幾筆
            API_URL: API_URL,
            //-------APP分類設定 (AppType)-------------start
            sort_disabled: true, // 排序功能是否停用
            listAppType: [], // 列表
            appTypeStartRowNum: 0,
            appTypeEndRowNum: 0,
            modalTitleForAPPType: "", // APP分類設定 - Modal的title
            btn_order: true, // 上方[重新排序]按鈕是否顯示
            btn_add: true, // 上方[新增APP分類按鈕]按鈕是否顯示
            // 上方編輯功能
            formstate: {}, // 驗證用
            iAppTypeStatusDesc: "", // 是新增or修改or刪除
            iAppTypeStatus: 0, // 新增or修改or刪除
            editAppTypeName: "", // Input APP分類名稱
            editOldAppTypeName: "", // 原APP分類名稱
            editAppTypeID: "", // 目前編輯/刪除的ID
            //-------APP分類設定 (AppType)-------------end
            //-------票券------------------------start
            selectListAppType: [], // APP分類下拉選單
            selectListTicketType: [], // 票券類別下拉選單
            // 發行型態
            selectListPublished: [
                {
                    t_Sid: 1,
                    t_SName: "常態"
                },
                {
                    t_Sid: 2,
                    t_SName: "限量"
                }
            ],
            querySaleNow: "yes", // 查詢條件:上架狀態 上架中
            querySaleSchedule: "yes", // 查詢條件:上架狀態 已排程
            listTicket0: [],
            listTicket1: [],
            listTicket2: [],
            //-------票券------------------------end
            content:
                "<div style='text-align: center'>✔消費任意兩客套餐，其中一份免費<br>️✔限量商品依各門市庫存為主，換完為止</div>",
            modelTitle: "",
            btn_top: true,
            picked: "",
            inputs: [],
            Top: [],
            dbTop: [],
            modalShow: false,
            addModalShow: false,
            //------EditTick--------------
            editModalShow: false,
            editTab: 0,
            editId: 0,
            editCode: '',
            editAllowTransfer: true,
            editAppSwap: true,
            editTicketType: '',
            editAppType: '',
            editTicketName: '',
            editTicketSpecies: 1,
            editTicketSpeciesDay: 0,
            editTicketSpeciesQty: 0,
            editTicketBuy: 1,
            editTicketBuyQty: 1,
            editCheckUpdId: '',
            editSaleDay_S: '',
            editSaleDay_E: '',
            editSaleDay_STime: '',
            editSaleDay_ETime: '',
            editCheckUpdTime: '',
            editUpdTime: '',
            editUpdId: '',
            editUseType: 1, // 使用管道
            editTicketRule: '', // 優惠規則
            editUseAmount: 0,
            editProduct_A: '',
            editProduct_B: '',
            products: [],
            editSaleDiscount: 0, // 銷售品折扣/金額
            editPoint: 0,
            editMoney: 0,
            editText: '',
            modelType: 0,
            editFree: false,
            editWeek: [],
            storeMode: 0,
            addStoreList: [],
            searchStoreList: [],
            useStartAt: 0,
            useEndAt: 0,
            dayMode: 0,
            memo: '',
            //-------Priview---------------
            previewSrc: "",
            previewName: "",
            previewPoint: "",
            previewDiscount: 0, // 折抵、折扣
            previewPosId: 0,
            previewPublished: "", // 發行型態 (1:常態, 2:限量)
            previewSaleDateE: "", // 兌換期限
            rdoCheckResult: 0,
            editdataUrl: undefined,
            delTicketName: "",
            delTicketIndex: 0,
            contactid: "",
            userImage: "",
            optionsWeek: [
                { text: '一', value: 1, disabled: true},
                { text: '二', value: 2, disabled: true},
                { text: '三', value: 3, disabled: true},
                { text: '四', value: 4, disabled: true},
                { text: '五', value: 5, disabled: true},
                { text: '六', value: 6, disabled: true},
                { text: '日', value: 0, disabled: true}
            ],
            citylist: new Map(), // 地區類別下拉
            selectedCity: [],
            city: '', // 地區
            store: { ID: 0, Code: '', Name: '' }, // 門市
            storelist: [{ ID: 0, Code: '', Name: '' }],
            showStoreList: [],
            addStoreAmount: 0,
            searchStoreAmount: 0,
            showStoreWord: '新增排除門市',
            model1: {
                currentPage: 1,
                totalrows: 0,
                rows: 10,
                startRowNum: 0,
                endRowNum: 0
            },
            selectListBrands: [{ ID: 0, Code: '', Text: '' }],
            selectBrands: [],
            v_BrandMsg: '',
            pointSubsidy: 0
        };
    },
    created () {
      this.FunctionPermission = getFunctionPermission('F10') // 功能權限 帶入功能代碼
      // 分頁處理 : for 第一次進查詢頁 & 從編輯頁跳回來時
        if (this.FunctionPermission > 0) {
            if (this.$route !== undefined) {
                if (this.$route.params.modelTab !== undefined) {
                this.modelTab = this.$route.params.modelTab
                }
                if (this.$route.params.queryTab0 !== undefined) {
                this.queryTab0 = this.$route.params.queryTab0
                }
                if (this.$route.params.querySaleNow !== undefined) {
                this.querySaleNow = this.$route.params.querySaleNow
                }
                if (this.$route.params.querySaleSchedule !== undefined) {
                this.querySaleSchedule = this.$route.params.querySaleSchedule
                }
                if (this.$route.params.queryTab1 !== undefined) {
                this.queryTab1 = this.$route.params.queryTab1
                }
                if (this.$route.params.queryTab2 !== undefined) {
                this.queryTab2 = this.$route.params.queryTab2
                }
                if (this.$route.params.collapse !== undefined) {
                this.collapse = this.$route.params.collapse
                }
            }
            this.changeTab(this.modelTab)
        } else {
            this.$router.push({ name: 'name' })
        }
    },
    components: {
        draggable
    },
    mounted: function () { },
    props: {
        value: {
            default: undefined
        }
    },
    methods: {
        resetForm1() {
            this.queryTab1.queryAppType1 = 0, // 查詢條件:APP分類
            this.queryTab1.queryTciketType1 = '', // 查詢條件:票券類別
            this.queryTab1.queryTciketName1 = '', // 查詢條件:票券名稱
            this.queryTab1.queryTciketPublished1 = 0, // 查詢條件:發行型態
            this.querySaleNow = "yes", // 查詢條件:上架狀態 上架中
            this.querySaleSchedule = "no" // 查詢條件:上架狀態 已排程
        },
        resetForm0() {
            this.queryTab0.queryAppType0 = 0, // 查詢條件:APP分類
            this.queryTab0.queryTciketType0 = '', // 查詢條件:票券類別
            this.queryTab0.queryTciketName0 = '', // 查詢條件:票券名稱
            this.queryTab0.queryTciketPublished0 = 0 // 查詢條件:發行型態
        },
        resetForm2() {
            this.queryTab2.queryAppType2 = 0, // 查詢條件:APP分類
            this.queryTab2.queryTciketType2 = '', // 查詢條件:票券類別
            this.queryTab2.queryTciketName2 = '', // 查詢條件:票券名稱
            this.queryTab2.queryTciketPublished2 = 0 // 查詢條件:發行型態
        },
        showTicketDetail (item,tab) {
          if (item.posCategoryCode.substr(0,3) === 'G01') {
            this.getAllProducts(item,tab)
          } else {
            this.editTicket(item,tab)
          }
        },
        getAllProducts (item,tab) {
            this.$parent.Loading = true
            axios.post(API_URL + '/web/shopping/getallproducts/v1', {
                status: 1,
                hasDelete: true,
                hasExtra: true,
                hasCombo: false,
                brandCode: item.brandCodes[0]
            })
                .then((response) => {
                    this.$parent.Loading = false

                    if (response.data.result === '0000') {
                        this.products = response.data.data
                        this.editTicket(item,tab)
                    } else if (response.data.result === '0006') {
                        this.$parent.logOut(true, true)
                    } else {
                        miniToastr.error(response.data.message, '商品資料讀取異常')
                    }
                })
                .catch((error) => {
                    this.$parent.Loading = false
                    miniToastr.error(error, '商品資料讀取異常')
                })
        },
        onSubmit_APP: function () {
            if (this.formstate.$invalid) {
            } else {
                this.openEditAppTypeModal()
            }
        },
        changeTab (tab) {
            this.tab = tab
            if (tab === 0) {
                this.queryTab0.currentPage = 1
            } else if (tab === 1) {
                this.queryTab1.currentPage = 1
            } else if (tab === 2) {
                this.queryTab2.currentPage = 1
            }
            // this.currentPage = 1
            this.query(tab)
        },
        query (tab) {
            if (tab === 3) {
                this.$parent.Loading = true
                return axios.post(API_URL + '/web/ticket/categoryquery')
                    .then((response) => {
                        if (response.data.result === '0000') {
                          this.listAppType = response.data.data
                          this.appTypeStartRowNum = (response.data.data === undefined || response.data.data === null || response.data.data.length === 0) ? 0 : 1
                          this.appTypeEndRowNum = (response.data.data === undefined || response.data.data === null ||response.data.data.length === 0) ? 0 : response.data.data.length
                        } else {
                            if (response.data.result === '0006') {
                                this.$parent.logOut(false, true)
                            } else {
                                miniToastr.error(response.data.message, '錯誤訊息')
                            }
                        }
                        this.$parent.Loading = false
                    })
                    .catch((error) => {
                        miniToastr.error(error, '錯誤訊息')
                        this.$parent.Loading = false
                    })
            } else {
                var current = 1
                if (tab === 0) {
                    current = this.queryTab0.currentPage
                } else if (tab === 1) {
                    current = this.queryTab1.currentPage
                } else if (tab === 2) {
                    current = this.queryTab2.currentPage
                }

                this.$parent.Loading = true
                return axios.post(API_URL + '/web/ticket/querydropdown')
                    .then((response) => {
                        if (response.data.result === '0000') {
                            this.selectListAppType = response.data.data.appcategory
                            this.selectListTicketType = response.data.data.poscategory
                            this.search(current)
                        } else {
                            if (response.data.result === '0006') {
                                this.$parent.logOut(false, true)
                            } else {
                                miniToastr.error(response.data.message, '錯誤訊息')
                            }
                        }
                        this.$parent.Loading = false
                    })
                    .catch((error) => {
                        miniToastr.error(error, '錯誤訊息')
                        this.$parent.Loading = false
                    })
            }
        },
        search: function (currentPage) {
            var querySale = 0 // 上架狀態
            if (this.tab === 1) {
                if (this.querySaleSchedule === 'no') {
                    querySale = 2
                } else if (this.querySaleNow === 'no') {
                    querySale = 1
                } else {
                    querySale = 0
                }
            }
            if (this.tab === 3) {
                this.$parent.Loading = true
                return axios.post(API_URL + '/web/ticket/categoryquery')
                    .then((response) => {
                        if (response.data.result === '0000') {
                            this.listAppType = response.data.data
                            this.appTypeStartRowNum = (response.data.data === undefined || response.data.data.length === 0) ? 0 : 1
                            this.appTypeEndRowNum = (response.data.data === undefined || response.data.data.length === 0) ? 0 : response.data.data.length
                        } else {
                            if (response.data.result === '0006') {
                                this.$parent.logOut(false, true)
                            } else {
                                miniToastr.error(response.data.message, '錯誤訊息')
                            }
                        }
                        this.$parent.Loading = false
                    })
                    .catch((error) => {
                        miniToastr.error(error, '錯誤訊息')
                        this.$parent.Loading = false
                    })
            } else {
                var appCategoryID = 0
                var posCategoryCode = ''
                var name = ''
                var published = 0
                var ReleaseStatus = 0

                if (this.tab == 0) {
                    if (currentPage == 1) {
                        this.queryTab0.currentPage = currentPage
                    }
                    appCategoryID = Number(this.queryTab0.queryAppType0)
                    posCategoryCode = this.queryTab0.queryTciketType0
                    name = this.queryTab0.queryTciketName0
                    published = Number(this.queryTab0.queryTciketPublished0)
                } else if (this.tab == 1) {
                    if (currentPage == 1) {
                        this.queryTab1.currentPage = currentPage
                    }
                    appCategoryID = Number(this.queryTab1.queryAppType1)
                    posCategoryCode = this.queryTab1.queryTciketType1
                    name = this.queryTab1.queryTciketName1
                    published = Number(this.queryTab1.queryTciketPublished1)
                    ReleaseStatus = Number(querySale) // 上架狀態 1:已排程 2:上架中 0:全選
                } else if (this.tab == 2) {
                    if (currentPage == 1) {
                        this.queryTab2.currentPage = currentPage
                    }
                    appCategoryID = Number(this.queryTab2.queryAppType2)
                    posCategoryCode = this.queryTab2.queryTciketType2
                    name = this.queryTab2.queryTciketName2
                    published = Number(this.queryTab2.queryTciketPublished2)
                }
                this.$parent.Loading = true
                return axios.post(API_URL + '/web/ticket/query', {
                    toPage: currentPage,
                    perPage: this.pageRows,
                    appCategoryID: appCategoryID, // APP分類
                    posCategoryCode: posCategoryCode, // 票券類別
                    name: name, // 票券名稱
                    published: published, // 發行型態 (1:常態, 2:限量)
                    status: Number(this.tab), // tab 0:草稿 1:發佈 2:下架
                    ReleaseStatus: ReleaseStatus, // 上架狀態 1:已排程 2:上架中 0:全選
                    onTop: !this.btn_top
                })
                    .then((response) => {
                        if (response.data.result === '0000') {
                            if (this.tab === 0) {
                                this.queryTab0.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
                                this.listTicket0 = response.data.data
                                this.queryTab0.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageRows * (this.queryTab0.currentPage - 1) + 1
                                this.queryTab0.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageRows > response.data.totalRows) ? response.data.totalRows : (this.queryTab0.currentPage * this.pageRows) >= response.data.totalRows ? response.data.totalRows : this.queryTab0.currentPage * this.pageRows
                            } else if (this.tab === 1) {
                                this.searchAppType1 = this.queryTab1.queryAppType1
                                this.queryTab1.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
                                this.listTicket1 = response.data.data
                                this.queryTab1.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageRows * (this.queryTab1.currentPage - 1) + 1
                                this.queryTab1.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageRows > response.data.totalRows) ? response.data.totalRows : (this.queryTab1.currentPage * this.pageRows) >= response.data.totalRows ? response.data.totalRows : this.queryTab1.currentPage * this.pageRows
                                if (this.btn_top) {
                                    var arrTop = []
                                    if (response.data.top != undefined) {
                                        response.data.top.forEach(function (item, Index) {
                                            arrTop.push({
                                                id: item.id,
                                                appCategoryID: item.appCategoryID,
                                                name: item.name,
                                                appCategoryName: item.appCategoryName,
                                                isUpdate: false
                                            })
                                        })
                                    }
                                    this.Top = arrTop.slice()
                                    this.dbTop = arrTop.slice()
                                }
                            } else if (this.tab === 2) {
                                this.listTicket2 = response.data.data
                                this.queryTab2.totalRows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
                                this.queryTab2.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.pageRows * (this.queryTab2.currentPage - 1) + 1
                                this.queryTab2.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.pageRows > response.data.totalRows) ? response.data.totalRows : (this.queryTab2.currentPage * this.pageRows) >= response.data.totalRows ? response.data.totalRows : this.queryTab2.currentPage * this.pageRows
                            }
                        } else {
                            if (response.data.result === '0006') {
                                this.$parent.logOut(false, true)
                            } else {
                                miniToastr.error(response.data.message, '錯誤訊息')
                            }
                        }
                        this.$parent.Loading = false
                    })
                    .catch((error) => {
                        miniToastr.error(error, '錯誤訊息')
                        this.$parent.Loading = false
                    })
            }
        },
        onEditorChange ({ editor, html, text }) {
            this.content = html;
        },
        nowDate: function () {
            var time = new Date();
            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var day = time.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }
            return year + "-" + month + "-" + day;
        },
        handleFileChange (e) {
            let inputDOM = this.$refs.inputer;
            this.file = inputDOM.files[0];
            this.$emit("input", this.file);
            this.fileName = this.file.name;
            this.imgPreview(this.file);
        },
        imgPreview (file) {
            let self = this;
            if (!file || !window.FileReader) return;

            if (/^image/.test(file.type)) {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function () {
                    self.dataUrl = this.result;
                };
            }
        },
        edithandleFileChange (e) {
            let inputDOM = this.$refs.editinputer;
            this.file = inputDOM.files[0];
            this.$emit("input", this.file);
            this.fileName = this.file.name;
            this.editimgPreview(this.file);
        },
        editimgPreview (file) {
            let self = this;
            if (!file || !window.FileReader) return;

            if (/^image/.test(file.type)) {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function () {
                    self.editdataUrl = this.result;
                };
            }
        },
        async editTicket (item, tab) {
            this.editTab = tab;
            this.editAllowTransfer = item.allowTransfer;
            this.editAppSwap = item.appswap;
            this.editAppType = item.appCategoryID;
            this.editTicketName = item.name;
            this.editSaleDay_S = item.enabledAt.replace(/\//g, '-');
            this.editSaleDay_E = item.disabledAt.replace(/\//g, '-');
            this.editSaleDay_STime = item.enabledAtTime
            this.editSaleDay_ETime = item.disabledAtTime
            this.editUseDay_S = item.applicableStartAt.replace(/\//g, '-');
            this.editUseDay_E = item.applicableEndAt.replace(/\//g, '-');
            this.editTicketSpecies = item.published;
            this.editTicketSpeciesDay = item.days;
            this.editTicketSpeciesQty = item.amount;
            this.editTicketType = item.posCategoryCode;
            this.editPoint = item.bonus;
            this.editMoney = item.discount;
            this.editId = item.code;
            this.editdataUrl = item.imageURL;
            this.editUpdId = item.updatedName;
            this.editUpdTime = item.updatedAt;
            this.editText = item.text;
            this.editCheckUpdId = item.releaseName;
            this.editCheckUpdTime = item.releaseAt;
            this.content = "<style>.ql-size-small{font-size: 0.75em;}.ql-size-large{font-size: 1.5em;}.ql-size-huge {font-size: 2.5em;}.ql-align-right{text-align: right;}.ql-align-center{text-align: center;}</style>"+item.comment;
            this.editFree = item.isfree;
            this.editWeek = JSON.parse('[' + item.week + ']');
            this.modelTitle = "電子票券明細";
            this.editTicketBuy = item.limitType;
            this.editTicketBuyQty = item.limitQty;
            this.editUseType = item.useType
            this.storeMode = item.storeMode
            this.addStoreList = item.storeList
            this.useStartAt = (item.useStartAt === '') ? 0 : parseInt(item.useStartAt.split(':')[0], 10)
            this.useEndAt = (item.useEndAt === '') ? 0 : parseInt(item.useEndAt.split(':')[0], 10)
            this.dayMode = item.dayMode
            this.memo = item.memo
            this.pointSubsidy = item.pointSubsidy

             // 抓取門市清單
          await this.getpost()
          // 更新已新增門市清單
          const storeCodeList = this.addStoreList.map(store => store.Code)
          this.addStoreList = []
          this.citylist.forEach((stores, city) => {
            stores.forEach((store) => {
              if (storeCodeList.includes(store.Code)) {
                let storeObj = {...store} // copy object
                this.addStoreList.push(storeObj)
              }
            })
          })
            //建立顯示清單
            this.searchStoreList = JSON.parse(JSON.stringify([...this.addStoreList]))
            this.cityChange()

            this.selectBrands = item.brandCodes
            this.querySelectListBrands()
            this.getSearchStoreList(1)

            if (this.editUseType !== 2) {
                if (this.editTicketType.substr(0,3) === 'G01') {
                    this.editTicketRule = item.rule
                    var buyItem = this.products.find(x => x.Detail.find(d => d.Code === item.buyItemCode)).Detail.find(d => d.Code === item.buyItemCode)
                    if (item.rule === 1) {
                        var saleItem = this.products.find(x => x.Detail.find(d => d.Code === item.saleItemCode)).Detail.find(d => d.Code === item.saleItemCode)
                        this.editProduct_A = buyItem.Name
                        this.editProduct_B = saleItem.Name
                    } else if (item.rule === 2 || item.rule === 3) {
                        this.editProduct_A = buyItem.Name
                        this.editSaleDiscount = item.buyDiscount
                    } else if (item.rule === 4) {
                        this.editProduct_A = buyItem.Name
                        this.editSaleDiscount = item.saleDiscount
                    }
                } else {
                    this.editUseAmount = item.useAmount
                }
            }
            this.$refs.editTicket.show();
        },
        previewTicket (item) {
            this.previewSrc = item.imageURL
            this.previewName = item.name
            this.previewPoint = item.bonus; // 兌換點數
            this.previewSaleDateE = item.applicableEndAt; // 兌換期限
            this.previewPublished = item.published; // 發行型態 (1:常態, 2:限量)
            this.previewPosId = item.posCategoryCode;
            if (this.previewPosId === 'A01') {
                this.previewDiscount = '折抵' + item.discount + '元'
            } else if (this.previewPosId === 'C01') {
                this.previewDiscount = '折扣' + this.item.discount + '折'
            } else if (this.previewPosId === 'G01') {
                this.previewDiscount = item.text
            }

            this.$refs.previewTicket.show();
        },
        editCancel () {
            this.$refs.editTicket.hide();
        },
        onFileChange (e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            this.createImage(files[0]);
        },
        topChange (selected,item) {
            this.Top=[];
            // var result = this.Top.map(item => Object.values(item)[1]).indexOf(item.appCategoryID)
            // if (result > -1) {
            //     this.Top.splice(result, 1)
            // }
            if (selected) {
                this.Top.push({
                    id: item.id,
                    appCategoryID: item.appCategoryID,
                    isUpdate: true,
                    name: item.name,
                    appCategoryName: item.appCategoryName
                })
            }
        },
        createImage (file) {
            var reader = new FileReader();
            var vm = this;

            reader.onload = e => {
                vm.userImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        // APP分類設定 - 按下[新增APP分類]按鈕
        addAppTypeBy () {
            this.iAppTypeStatus = 1;
            this.iAppTypeStatusDesc = "新增";
            this.btn_add = false;
            this.editAppTypeName = "";
            this.editOldAppTypeName = "";
            this.modalTitleForAPPType = "新增APP分類";
        },
        //APP分類設定 - 按下列表編輯按鈕
        editAppTypeBy (index) {
            this.iAppTypeStatus = 2;
            this.iAppTypeStatusDesc = "修改";
            // this.iAppTypeIndex = index;
            this.editAppTypeID = this.listAppType[index].id;
            this.editAppTypeName = this.listAppType[index].name;
            this.editOldAppTypeName = "原名稱：" + this.listAppType[index].name;
            this.btn_add = false;
            this.modalTitleForAPPType = "修改APP分類";
        },
        //APP分類設定 - 按下列表刪除按鈕
        delAppTypeByOpen (index) {
            this.iAppTypeStatus = 3;
            this.iAppTypeStatusDesc = "刪除";
            // this.iAppTypeIndex = index;
            this.editAppTypeID = this.listAppType[index].id;
            this.editAppTypeName = this.listAppType[index].name;
            this.modalTitleForAPPType = "刪除APP分類";
            this.openEditAppTypeModal()
        },
        // APP分類設定 - 取消
        editAppTypeCancel () {
            this.btn_add = true;
            this.btn_order = true;
            this.editAppTypeName = "";
        },
        // APP分類設定 - 開啟是否要'增/刪/改'詢問視窗
        openEditAppTypeModal () {
            this.$refs.editAppTypeModal.show();
        },
        // 置頂 詢問視窗
        openTopModal () {
            this.$refs.TopModal.show();
        },
        TopCancel () {
            this.$refs.TopModal.hide();
        },
        btnTop () {
            if (this.btn_top) {
                if (this.queryTab1.queryAppType1 == '' || this.queryTab1.queryAppType1 == 0) {
                    miniToastr.error('請先查詢APP分類，進行單一分類設定置頂')
                } else {
                    if (this.searchAppType1 == this.queryTab1.queryAppType1) {
                        this.btn_top = !this.btn_top
                        this.Top = this.dbTop.slice()
                    } else {
                        miniToastr.error('查詢條件APP分類已變更，請重新查詢後再設定置頂')
                    }
                }
            } else {
                this.btn_top = !this.btn_top
                this.Top = this.dbTop.slice()
            }
        },
        // 置頂 - 儲存
        TopModalSave () {
            var id = 0
            var appCategoryID = this.queryTab1.queryAppType1
            if (this.Top != undefined && this.Top.length != 0) {
                id = this.Top[0].id
            }
            this.$parent.Loading = true
            return axios.post(API_URL + '/web/ticket/updatetop',
              {id: id, appCategoryID: appCategoryID})
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('更新成功')
                        this.btn_top = true
                        this.query(1)
                        this.$refs.TopModal.hide()
                        this.$parent.Loading = false
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                        this.$parent.Loading = false
                    }
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })
        },
        // APP分類設定 - Modal的增刪改
        editAppTypeModalSave () {
            if (!this.btn_add) {
                if (this.iAppTypeStatus === 1) { // 新增
                    this.$parent.Loading = true
                    return axios.post(API_URL + '/web/ticket/categorycreate', {
                        name: this.editAppTypeName,
                    })
                        .then((response) => {
                            if (response.data.result === '0000') {
                                miniToastr.success('新增成功')
                                this.editAppTypeModalReset()
                                this.query(3)
                            } else {
                                if (response.data.result === '0006') {
                                    this.$parent.logOut(false, true)
                                } else {
                                    miniToastr.error(response.data.message, '錯誤訊息')
                                }
                                this.$refs.editAppTypeModal.hide()
                                this.$refs.rAppTypeName.focus()
                            }
                            this.$parent.Loading = false
                        })
                        .catch((error) => {
                            miniToastr.error(error, 'Error')
                            this.$parent.Loading = false
                        })
                } else if (this.iAppTypeStatus === 2) { // 修改
                    this.$parent.Loading = true
                    return axios.post(API_URL + '/web/ticket/categoryupdate', {
                        id: this.editAppTypeID,
                        name: this.editAppTypeName
                    })
                        .then((response) => {
                            if (response.data.result === '0000') {
                                miniToastr.success('修改成功')
                                this.editAppTypeModalReset()
                                this.query(3)
                            } else {
                                if (response.data.result === '0006') {
                                    this.$parent.logOut(false, true)
                                } else {
                                    miniToastr.error(response.data.message, '錯誤訊息')
                                }
                                this.$refs.editAppTypeModal.hide()
                                this.$refs.rAppTypeName.focus()
                            }
                            this.$parent.Loading = false
                        })
                        .catch((error) => {
                            miniToastr.error(error, '錯誤訊息')
                            this.$parent.Loading = false
                        })
                }
            }
            // 刪除
            this.$parent.Loading = true
            return axios.post(API_URL + '/web/ticket/categorydelete', {
                id: this.editAppTypeID
            })
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('刪除成功')
                        this.editAppTypeModalReset()
                        this.query(3)
                        localStorage.setItem('TOKEN', response.data.jwt)
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                        this.$refs.editAppTypeModal.hide()
                    }
                    this.$parent.Loading = false
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })
        },
        // APP分類設定 - Modal的重設
        editAppTypeModalReset () {
            this.btn_add = true;
            this.btn_order = true;
            this.editAppTypeName = "";
            this.$refs.editAppTypeModal.hide();
        },
        // APP分類設定 - Modal的取消
        editAppTypeModalCancel () {
            this.$refs.editAppTypeModal.hide();
            this.editAppTypeModalReset()
        },
        // APP分類設定 - 按下重新排序按鈕
        editOrderBy () {
            this.btn_order = false;
            this.sort_disabled = false; // 啟用排序
        },
        // APP分類設定 - 儲存新的排序
        orderAppType () {
            // 取得id與新的排序
            var arrAll = []
            this.listAppType.forEach(function (arrRole, Index) {
                arrAll.push({
                    id: arrRole.id,
                    sort: Index + 1
                })
            })
            // call API
            this.$parent.Loading = true
            return axios.post(API_URL + '/web/ticket/categoryorder', {
                data: arrAll,
            })
                .then((response) => {
                    if (response.data.result === '0000') {
                        miniToastr.success('重新排序成功')
                        this.sort_disabled = true; // 停用排序
                        this.editAppTypeModalReset()
                        this.query(3)
                    } else {
                        if (response.data.result === '0006') {
                            this.$parent.logOut(false, true)
                        } else {
                            miniToastr.error(response.data.message, '錯誤訊息')
                        }
                    }
                    this.$parent.Loading = false
                })
                .catch((error) => {
                    miniToastr.error(error, '錯誤訊息')
                    this.$parent.Loading = false
                })
        },
        // APP分類設定 - 排序取消
        orderAppTypeCancel () {
            this.btn_add = true;
            this.btn_order = true;
            this.sort_disabled = true; // 停用排序
            this.query(3);
        },
        getpost () {
            this.$parent.Loading = true
            return axios.post(API_URL + '/web/shopping/getallstoresTowLevel/v1', {
              brandCode: this.selectBrands
            })
            .then((response) => {
                if (response.data.result === '0000') {
                    const mapCityList = new Map()
                    mapCityList.set('全部地區', [])
                    response.data.data.forEach(item => {
                        mapCityList.set(item.City, item.Stores.map(store => {
                            store.City = item.City
                            return store
                        }))
                    })
                    this.citylist = mapCityList
                    this.cityChange()
                    this.$store.commit('TOKEN', response.data.jwt)
                } else if (response.data.result === '0006') {
                    this.$parent.logOut(true, true)
                } else {
                    miniToastr.error(response.data.message, '資料讀取異常')
                    console.log(response.data.message)
                }
                this.$parent.Loading = false
            })
            .catch((error) => {
                console.log('CATCH')
                console.log(error)
                miniToastr.error(error.message, '資料讀取異常')
                this.$parent.Loading = false
            })
        },
        cityChange () {
            var city = this.city
            var plist = []
            if (this.citylist.has(city)) {
                this.citylist.get(city).sort((a, b) => a.ID - b.ID)
                plist = [...this.citylist.get(city)]
            }
            if (city.trim() !== '' && plist.length !== 0) {
                plist.unshift({
                    Code: 'ALL',
                    ID: 0,
                    Name: city + '全門市'
                })
            }
            this.updateSelectedCity()
            this.storelist = plist
            this.store = ''
        },
        refreshSearchStoreAmount () {
            // 查詢頁面顯示筆數總計
            this.searchStoreAmount = this.searchStoreList.length
            // 已新增門市總計
            this.addStoreAmount = this.addStoreList.length
            const mode = Number(this.storeMode)
            if (this.addStoreAmount > 0) {
                if (mode !== 1) {
                    this.showStoreWord = `已排除${this.selectedCity.length}個地區${this.addStoreAmount}間門市`
                } else if (mode === 1) {
                    this.showStoreWord = `已新增${this.selectedCity.length}個地區${this.addStoreAmount}間門市`
                }
            } else {
                if (mode !== 1) {
                this.showStoreWord = '無排除任何門市'
                } else if (mode === 1) {
                this.showStoreWord = '無限定使用門市'
                }
            }
        },
        handleSearch () {
            this.searchStoreList = JSON.parse(JSON.stringify([...this.addStoreList]))
            const city = this.city.trim()
            if (city && city !== '全部地區') {
                this.searchStoreList = this.searchStoreList.filter(store => store.City == this.city)
            }

            if (this.store && this.store.ID !== 0) {
                this.searchStoreList = this.searchStoreList.filter(store => store.Code == this.store.Code)
            }
            this.getSearchStoreList(1)
        },
        getSearchStoreList (currentPage) {
            this.refreshSearchStoreAmount()
            this.model1.currentPage = currentPage
            this.model1.totalrows = this.searchStoreAmount
            const startIndex = (this.model1.currentPage - 1) * this.model1.rows
            const endIndex = this.model1.currentPage * this.model1.rows
            if (!this.searchStoreList[startIndex] && this.searchStoreAmount > 0) {
                this.getSearchStoreList(currentPage - 1)
                return
            }
            let storesArray
            if (endIndex < this.searchStoreAmount) {
                storesArray = this.searchStoreList.slice(startIndex, endIndex)
            } else {
                storesArray = this.searchStoreList.slice(startIndex)
            }
            this.showStoreList = JSON.parse(JSON.stringify(storesArray)) // 複製物件否則底下Seq將影響原陣列內部之物件
            this.showStoreList.forEach((item, index) => {
                item.Seq = startIndex + index + 1
            })
            this.model1.startRowNum = (this.searchStoreAmount === 0) ? 0 : startIndex + 1
            this.model1.endRowNum = (this.searchStoreAmount === 0) ? 0 : (this.searchStoreAmount < endIndex) ? this.searchStoreAmount : endIndex
        },
        nameWithLang ({ Code, Name }) {
            return `${Code} — ${Name}`
        },
        updateSelectedCity () {
            if (this.addStoreList.length > 0) {
                this.selectedCity = [...new Set(this.addStoreList.map(store => store.City))]
            } else {
                this.selectedCity = []
            }
        },
        querySelectListBrands() {
          //品牌下拉選單
          axios
            .post(API_URL + "/web/brands/v1", {
              all: false,
              order: false
          })
          .then(response => {
            this.selectListBrands = response.data.data;
            this.$parent.Loading = false;
          })
          .catch(error => {
            this.selectListBrands = [];
            this.$parent.Loading = false;
            miniToastr.error(error, "資料讀取異常");
            console.log(error);
          });
        },
        addStoreShow () {
          this.$refs.addStore.show()
          this.getpost()
        }
    },
    computed: {
        // 排序參數設定
        dragOptions () {
            return {
                disabled: this.sort_disabled,
            }
        },
        placeholderText () {
            return (!this.city || this.storelist.length) ? '請選擇' : '已涵蓋所有門市'
        },
        isDisable () {
            return (!this.city || this.storelist.length === 0)
        }
    }
}
</script>
<style scoped>
.upload_block {
  position: relative;
  width: 220px;
  height: 140px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background: #f1f1f1;
  border: 3px dashed #d6d4d4;
}
.upload_input {
  display: none;
}
.upload_img {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 2;
}
.upload_icon {
  font-weight: bold;
  font-size: 200%;
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  top: 35%;
}
.cursor_add_store {
  cursor: pointer;
}
.cursor_add_store:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/pages/coupon/exchange/List.vue